// src/env/index.ts
var VITE_BUILT_INS = /* @__PURE__ */ new Set(["BASE_URL", "MODE", "DEV", "PROD", "SSR"]);
function readEnvKey(source, name) {
  const candidates = [`VITE_${name}`, `REACT_APP_${name}`];
  if (!VITE_BUILT_INS.has(name)) candidates.push(name);
  for (const c of candidates) {
    const v = source[c];
    if (v !== void 0 && v !== "") return String(v);
  }
  return void 0;
}
function normaliseDeployEnv(value) {
  const v = (value ?? "local").toLowerCase();
  const known = ["local", "dev", "sandbox", "qa", "staging", "prd"];
  if (known.includes(v)) return v;
  if (v === "production" || v === "prod") return "prd";
  if (v === "development") return "dev";
  return "local";
}
function claimsNamespaceOf(value) {
  const withScheme = /^https?:\/\//.test(value) ? value : `https://${value}`;
  return withScheme.endsWith("/") ? withScheme : `${withScheme}/`;
}
function resolveEnv(source = {}) {
  const raw = {};
  for (const [k, v] of Object.entries(source)) raw[k] = v === void 0 ? void 0 : String(v);
  const apiBaseDomain = readEnvKey(source, "API_BASE_URL") ?? "authe.io";
  return {
    env: normaliseDeployEnv(readEnvKey(source, "ENV")),
    apiBaseDomain,
    // The Auth0 custom-claim prefix (`https://sandbox.authe.io/qa_config`, …).
    // Derived from the API domain rather than defaulted to the prd one: the two
    // are the same host in every environment, and a namespace that silently
    // says "authe.io" while the app talks to sandbox is the failure this field
    // keeps having. `CLAIMS_NAMESPACE` is the explicit name; `BASE_URL` stays
    // for the apps that already set it (prefixed only — see VITE_BUILT_INS).
    claimsNamespace: claimsNamespaceOf(
      readEnvKey(source, "CLAIMS_NAMESPACE") ?? readEnvKey(source, "BASE_URL") ?? apiBaseDomain
    ),
    sourcePlatform: readEnvKey(source, "SOURCE_PLATFORM") ?? "dashboard",
    policyCdnUrl: readEnvKey(source, "POLICY_CDN_URL") ?? `https://cdn.${apiBaseDomain}`,
    privateApiGraphqlUrl: readEnvKey(source, "PRIVATE_API_GRAPHQL_URL"),
    auth0Domain: readEnvKey(source, "AUTH0_DOMAIN"),
    auth0ClientId: readEnvKey(source, "AUTH0_CLIENT_ID"),
    auth0Audience: readEnvKey(source, "AUTH0_AUDIENCE"),
    sentryDsn: readEnvKey(source, "SENTRY_DSN"),
    rumAppId: readEnvKey(source, "RUM_APP_ID"),
    rumIdentityPoolId: readEnvKey(source, "RUM_IDENTITY_POOL_ID"),
    rumRegion: readEnvKey(source, "RUM_REGION"),
    raw
  };
}
function isProd(env) {
  return env.env === "prd";
}
function isLocal(env) {
  return env.env === "local";
}
function isSandbox(env) {
  return env.env === "sandbox";
}
function isQa(env) {
  return env.env === "qa";
}
var DEPLOY_ENVS = ["local", "dev", "sandbox", "qa", "staging", "prd"];
function backendDeployment(env) {
  if (env.env !== "local") return env.env;
  const domain = (env.apiBaseDomain || "").toLowerCase();
  if (domain === "authe.io") return "prd";
  const sub = domain.split(".")[0];
  return DEPLOY_ENVS.includes(sub) ? sub : "local";
}

export { backendDeployment, isLocal, isProd, isQa, isSandbox, readEnvKey, resolveEnv };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map